export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8899.498384b6.jpg";